import React, { useEffect, useState } from 'react';
import { usePageTitle } from './hooks/usePageTitle';

function ResetPassword() {
  usePageTitle('Reset Password');
  let [loading, setLoading] = useState<boolean>(false);
  let [error, setError] = useState<string>('');

  async function handleSubmitResetPassword(
    e: React.FormEvent<HTMLFormElement>
  ) {
    e.preventDefault();

    setLoading(true);
    const form = e.currentTarget as HTMLFormElement;
    const form_data = new FormData(form);

    const email = String(form_data.get('account-email') || '');
    if (!email || email.trim().length === 0) {
      setError('No email entered.');
      setLoading(false)
      return;
    }

    try {
      const res = await fetch('/api/login/passwordreset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email: email})
      })

      if (!res.ok) {
        throw new Error('Request failed');
      }

    } catch(e) {
      console.error('Error requesting password reset.')
      setError(e instanceof Error ? e.message : 'Failed to make password reset request.')
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div
      id="ts-login-wrapper"
      className="w-full h-full p-8 flex flex-col items-center justify-center"
    >
      <div
        id="ts-loginresetpassword-card"
        className="w-1/3 h-fit p-4 flex flex-col rounded-sm items-center justify-center border-light-border border shadow-sm"
      >
        <div
          id="ts-loginresetpassword-title"
          className="text-2xl font-bold mt-4"
        >
          Reset Your Password
        </div>
        <div
          id="ts-loginresetpassword-subtitle"
          className="text-normal text-center p-2"
        >
          Request a change to the password of your existing account.
        </div>
        <div className="w-full px-4 py-2">
          <form
            name="tsloginresetpassword"
            method="POST"
            id="ts-loginresetpassword-form"
            className="flex w-full flex-col items-center justify-center gap-4 mb-2"
            onSubmit={handleSubmitResetPassword}
          >
            <label htmlFor="ts-loginresetpassword-form-accountemail">
              Email
            </label>
            <input
              className="w-full p-2 border-light-border border focus:border-light-main"
              type="text"
              id="ts-loginresetpassword-form-accountemail"
              name="account-email"
              placeholder="Your Email"
              aria-label="Your Email"
              required
            />

            <button
              id="ts-login-form-submit"
              className="w-1/2 rounded-sm p-2 cursor-pointer bg-light-main text-light-text-alt disabled:opacity-60"
              type="submit"
              disabled={loading}
            >
              {loading ? 'Requesting...' : 'Request Reset'}
            </button>
          </form>
          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
              {error}
            </div>
          )}
        </div>
      </div>
      <div className="w-1/2 relative mt-4 flex items-center justify-center p-4">
        <span>
          Looking to apply for an account? See{' '}
          <a className="text-light-text-link" href="/sales-faq">
            Sales FAQ
          </a>{' '}
          &{' '}
          <a className="text-light-text-link" href="/about-us/contact-us">
            Contact Us
          </a>
        </span>
      </div>
    </div>
  );
}

export default ResetPassword;
